import { or } from '@ember/object/computed';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  unitToken: attr(String),
  unitName: attr(String),
  displayName: attr(String),
  displayNameOrUnitName: or('displayName', 'unitName')
});